import { connect } from "react-redux";

import IntegrationsView from "./IntegrationsView.jsx";
import {trackAdoptionMetricsForIntegrationsFilteredEvent} from "src/legacy/redux/actions/adoption";
import {trackAdoptionMetricsForIntegrationPartnerSelectedEvent} from "src/legacy/redux/actions/adoption";
import { fetchIntegrations } from "src/legacy/redux/actions/integrations.jsx";
import hasAccess from "src/legacy/services/hasAccess.jsx";
import withUseHooks from "src/legacy/components/withUseHooks.jsx";
import { fetchActivatedWorkspaces } from 'src/legacy/redux/actions/integrations/cleverstory.jsx';
import _ from "lodash";

const mapStateToProps = (state, ownProps) => {
  return {
    user: state.users.me,
    loading: state.legacyRootReducer.settings.integrations.activated.loading,
    integrations: state.legacyRootReducer.settings.integrations,
    activatedIntegrations : state.legacyRootReducer.settings.integrations.activated.items,
    isCleverstoryIntegrated: _.get(state, "accounts.item.cleverstoryIntegration", false),
    isEmployerAdvocacyEnabled: _.get(state, "accounts.item.employerAdvocacyEnabled", false),
    activatedWorkspaces: _.get(state, "legacyRootReducer.settings.integrations.cleverstory.activatedWorkspaces.items", [])
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchIntegrations: () => {
      return dispatch(fetchIntegrations());
    },
    trackAdoptionMetricsForIntegrationsFilteredEvent: (filter) =>{
      return dispatch(trackAdoptionMetricsForIntegrationsFilteredEvent(filter))
    },
    trackAdoptionMetricsForIntegrationPartnerSelectedEvent: (partnerName) =>{
      return dispatch(trackAdoptionMetricsForIntegrationPartnerSelectedEvent(partnerName))
    },
    fetchActivatedWorkspaces: () => {
      return dispatch(fetchActivatedWorkspaces());
    }
  };
};

const IntegrationsPage = connect(
  mapStateToProps,
  mapDispatchToProps
)(IntegrationsView);

export default withUseHooks(IntegrationsPage);
// export default hasAccess(IntegrationsPage, 'integrations');
